var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcCheckmark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.75 18L3 11.25L4.0605 10.1895L9.75 15.8783L19.9395 5.68951L21 6.75001L9.75 18Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcCheckmark);
export default __webpack_public_path__ + "static/media/ic-checkmark.68c57f716803a861b26452685da4533e.svg";
export { ForwardRef as ReactComponent };